module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-blue-26bd6172.png";